import React from 'react'

import { SchemaCustomfield } from '@/__generated/es-api'
import TableRowActions from '@/app/component/layout/table/actions'

type Props = {
  customField: SchemaCustomfield
  onEdit: (customField: SchemaCustomfield) => void
  onDelete: (customField: SchemaCustomfield) => void
}

const CustomFieldActionMenu: React.FC<Props> = ({ customField, onEdit, onDelete }) => {
  const config = React.useMemo(() => {
    const actions = []

    actions.push({
      icon: 'edit',
      label: 'Edit',
      onClick: () => onEdit(customField),
      tooltip: `Edit ${customField.name}`,
    })

    actions.push({
      icon: 'delete',
      label: 'Delete',
      onClick: () => onDelete(customField),
      tooltip: `Delete ${customField.name}`,
    })

    return actions
  }, [customField, onEdit, onDelete])

  return <TableRowActions config={config} />
}

export default CustomFieldActionMenu
